import React, { useEffect, useRef, useState, useCallback } from "react";
// import CrossBTN from "../../Assets/cross-earn.png";
import Logo2 from "../../Assets/main-logo.png";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import sidebarImg from "../../Assets/sidenav-img.png";
import order from "../../Assets/order1.svg";
import contact from "../../Assets/contact.svg";
// import star from "../../Assets/Star.svg";
import profile from "../../Assets/profile1.svg";
// import staticGiftLogo from "../../Assets/NewList/powered-gift.png";
import getTranslationData from "../../TranslationUtility/TranslationUtility";
import {
  ApplyThemeStyles,
  ClientInfo,
  getConfigValue,
  GetImageUrl,
  ThemeData,
  trackEvent,
} from "../../Components/Utility/Utility";
// import { Logout } from "../../Components/Icons";
import { getProductList } from "../../Store/Slices/productSlice";
import logout from "../../../src/Assets/logout_new.png";
import { setProduct } from "../../Store/Slices/productDataSlice";
import { encryptURLParam } from "../../Common/Axios/encrypt";

const MobileHeader = ({
  scroll,
  matchCategory,
  getInitials,
  validateLoginTokenData,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const translation = getTranslationData();
  const themeData = ThemeData();
  const [OpenModal, setOpenModal] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredResults, setFilteredResults] = useState([]);
  const [isSearching, setIsSearching] = useState(false);
  const [showSearch, setShowSearch] = useState(false);
  const [firstPageLoaded, setFirstPageLoaded] = useState(false);
  const dropdownRef = useRef(null);
  const modal = useRef(null);
  const locationPath = useLocation();
  const hasFooter = locationPath?.pathname?.includes("static");
  const [showPromotional, setShowPromotional] = useState(true);
  const isLogin = sessionStorage.getItem("login");
  const [isModal, setIsModal] = useState(false);
  const isOpen = true;
  const [isSearchActive, setIsSearchActive] = useState(false);
  const [searchPageNumber, setSearchPageNumber] = useState(1);
  const [hasMoreSearchResults, setHasMoreSearchResults] = useState(true);
  const [isLoadingMore, setIsLoadingMore] = useState(false);
  const [keepTyping, setKeepTyping] = useState(false);
  const searchLoaderRef = useRef(null);

  const handleChangeOptimized = (e) => {
    const value = e.target.value;
    setSearchTerm(value);
    setIsSearchActive(true);

    if (value.trim() === "") {
      setFilteredResults([]);
      setSearchPageNumber(0);
      setHasMoreSearchResults(true);
      setFirstPageLoaded(false);
      setKeepTyping(false);
      setIsSearching(false);
      return;
    }

    if (value.trim().length < 3) {
      setFilteredResults([]);
      setSearchPageNumber(0);
      setHasMoreSearchResults(true);
      setFirstPageLoaded(false);
      setKeepTyping(true); // show keep typing
      setIsSearching(false); // hide "no record"
      return;
    }
    setKeepTyping(false);
    setIsSearching(false);
    setIsLoadingMore(true);

    // reset pagination
    setFilteredResults([]);
    setSearchPageNumber(0);
    setHasMoreSearchResults(true);
    setFirstPageLoaded(false);

    const payload = {
      search: value,
      pageNumber: 1,
      pageSize: 10,
    };

    dispatch(getProductList(payload))
      .then((response) => {
        const data = response?.payload?.response?.products || [];
        const totalCount = response?.payload?.response?.totalCount || 0;

        setFilteredResults(data);
        setHasMoreSearchResults(data.length < totalCount);
        setSearchPageNumber(1); // last loaded page
        setFirstPageLoaded(true);

        // 3️⃣ ≥3 chars but no results
        if (data.length === 0) {
          setIsSearching(true); // show "No record found"
        }
      })
      .finally(() => {
        setIsLoadingMore(false);
      });
  };

  const handleLogin = () => {
    const pathName = window.location.pathname;
    const search = window.location.search;
    localStorage.setItem("ProductListPage", pathName + search);
    localStorage.setItem("ProductListPage_back", pathName + search);
  };
  // Load more search results
  const loadMoreSearchResults = useCallback(() => {
    if (
      isLoadingMore ||
      !hasMoreSearchResults ||
      !firstPageLoaded ||
      searchTerm.trim().length < 3
    ) {
      return;
    }

    setIsLoadingMore(true);
    const nextPage = searchPageNumber + 1;

    const payload = {
      search: searchTerm,
      pageNumber: nextPage,
      pageSize: 10,
    };

    dispatch(getProductList(payload))
      .then((response) => {
        const newData = response?.payload?.response?.products || [];
        const totalCount = response?.payload?.response?.totalCount || 0;

        setFilteredResults((prev) => {
          const updated = [...prev, ...newData];
          setHasMoreSearchResults(updated.length < totalCount);
          return updated;
        });

        setSearchPageNumber(nextPage);
      })
      .finally(() => {
        setIsLoadingMore(false);
      });
  }, [
    searchTerm,
    searchPageNumber,
    isLoadingMore,
    hasMoreSearchResults,
    firstPageLoaded,
    dispatch,
  ]);

  // IntersectionObserver for search dropdown infinite scroll
  useEffect(() => {
    if (
      !searchLoaderRef.current ||
      !isSearchActive ||
      !hasMoreSearchResults ||
      !firstPageLoaded
    ) {
      return;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !isLoadingMore) {
          loadMoreSearchResults();
        }
      },
      {
        root: null,
        rootMargin: "120px",
        threshold: 0,
      },
    );

    observer.observe(searchLoaderRef.current);

    return () => observer.disconnect();
  }, [
    filteredResults.length,
    isSearchActive,
    hasMoreSearchResults,
    firstPageLoaded,
    isLoadingMore,
    loadMoreSearchResults,
  ]);

  // const ClientProducts = useSelector(
  //   (state) =>
  //     state?.ClientProductMappingbyIdReducer.data?.[0]?.clientProductMapping
  // );
  // const handleChange = (e) => {
  //   const searchValue = e.target.value;
  //   setSearchTerm(searchValue);
  //   setIsSearching(true);
  //   setIsSearchActive(true);

  //   if (searchValue.trim() === "") {
  //     setFilteredResults([]);
  //     setIsSearchActive(false);
  //     return;
  //   }

  //   const filteredData = productData?.filter((item) => {
  //     const matchesSearch = item?.name
  //       ?.toLowerCase()
  //       .includes(searchValue?.toLowerCase());
  //     const clientMapping = ClientProducts?.find(
  //       (cp) => cp.productId === item.id
  //     );

  //     // check priceDenomination invalid
  //     const invalidDenom =
  //       clientMapping &&
  //       (!clientMapping.priceDenomination ||
  //         clientMapping.priceDenomination === "0" ||
  //         clientMapping.priceDenomination.trim() === "");

  //     // exclude if invalidDenom true
  //     return matchesSearch && !invalidDenom;
  //   });

  //   setFilteredResults(filteredData);
  // };

  const promotionalList = useSelector((state) => state.promotionalReducer);
  const [promotinalData, setPromotionalData] = useState();
  // const firstName = validateLoginTokenData.firstName;
  // const lastName = validateLoginTokenData.lastName;
  const firstName = validateLoginTokenData?.memberProfile?.firstName ?? "";
  const lastName = validateLoginTokenData?.memberProfile?.lastName ?? "";

  useEffect(() => {
    if (Array.isArray(promotionalList?.GetPromotional)) {
      const today = new Date().setHours(0, 0, 0, 0);

      const filteredData = promotionalList?.GetPromotional?.filter((item) => {
        const startDate = new Date(item.startDate).setHours(0, 0, 0, 0);
        const endDate = new Date(item.endDate).setHours(0, 0, 0, 0);
        return item.enabled === true && startDate <= today && endDate >= today;
      });

      setPromotionalData(filteredData);
    }
  }, [promotionalList?.GetPromotional]);

  const handleClick = (item) => {
    trackEvent("search_product", {
      search_term: item?.name,
      found_count: "",
      search_url: window.location.href,
    });
    dispatch(setProduct(item));
    // Conditionally encrypt the productId parameter based on environment setting
    const productId = item?.id.toString();
    const finalProductId =
      process.env.REACT_APP_IS_ENCRYPTION_ENABLED === "false"
        ? productId
        : encryptURLParam(productId);
    navigate(`/giftcard?productId=${finalProductId}`, { state: { item } });
    setSearchTerm("");
    setIsSearchActive(false);
    setShowSearch(false);
  };
  const handleClickOutside = (event) => {
    if (
      (dropdownRef.current && !dropdownRef.current.contains(event.target)) ||
      (modal.current && !modal.current.contains(event.target))
    ) {
      setFilteredResults([]);
      setSearchTerm("");
      setIsSearchActive(false);
      setShowSearch(false);
      //setIsModal(false);
    }
    if (
      modal.current &&
      !modal.current.contains(event.target) &&
      !event.target.closest(".meiconbtn")
    ) {
      setIsModal(false);
    }
  };
  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    window.addEventListener("scroll", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (OpenModal) {
      document.body.classList.add("modal-open");
    } else {
      document.body.classList.remove("modal-open");
    }

    return () => {
      document.body.classList.remove("modal-open");
    };
  }, [OpenModal]);

  const toggleSearchBar = () => {
    if (showSearch) {
      // closing search: always deactivate and reset state
      setShowSearch(false);
      setIsSearchActive(false);
      setSearchTerm("");
      setFilteredResults([]);
      setSearchPageNumber(1);
      setHasMoreSearchResults(true);
    } else {
      // opening search: activate and clear prior results
      setShowSearch(true);
      setIsSearchActive(true);
      setSearchTerm("");
      setFilteredResults([]);
      setSearchPageNumber(1);
      setHasMoreSearchResults(true);
    }
  };

  const currentBalance = useSelector((state) =>
    state.cardDataSliceReducer?.pointBalance,
  );
  const V3Data = useSelector((state) => state.cardDataSliceReducer);
  const clientinfo = ClientInfo();
  useEffect(() => {
    if (showSearch) {
      document.body.classList.add("no-scroll");
    } else {
      document.body.classList.remove("no-scroll");
    }
  }, [showSearch]);

  useEffect(() => {
    ApplyThemeStyles(themeData);
  }, [themeData]);
  const handleLogout = (e) => {
    navigate("/logout");
  };
  const clientConfigurations = clientinfo?.clientData?.clientConfigurations;
  const isLoginDisabled = getConfigValue(clientConfigurations, "isLogin");
  const isEarn = clientConfigurations?.find(
    (item) => item.configKey.toLowerCase() === "isearn",
  )?.configValue;
  const isBurn = clientConfigurations?.find(
    (item) => item.configKey.toLowerCase() === "isburn",
  )?.configValue;
  return (
    <header className="header desktop-hide">
      {isSearchActive ? <div className="screen-blur" /> : ""}

      {OpenModal && (
        <div className="backdrop" onClick={() => setOpenModal(false)}></div>
      )}

      <div className={`fixheader top-hh ${scroll && "sticky"}`}>
        {showPromotional &&
          Array?.isArray(promotinalData) &&
          promotinalData?.map((item) => (
            <div className="oaoa top-hh" key={item.id}>
              <div className="d-flex align-items-baseline">
                <p className="promo width-fit-content">{item?.titleText}</p>
                {item?.link && item?.linkText && (
                  <p className="mt-2 pro_link width-fit-content">
                    <Link to={item?.link} className="exp">
                      <span
                        dangerouslySetInnerHTML={{ __html: item?.linkText }}
                      />
                      <i className="fa-solid fa-arrow-right"></i>
                    </Link>
                  </p>
                )}
              </div>
              <button
                className="close-Btn pr-2"
                onClick={() => setShowPromotional(false)}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="21"
                  height="21"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="var(--explore-earn-text-color)"
                  stroke-width="3"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <line x1="20" y1="8" x2="8" y2="20" />
                  <line x1="8" y1="8" x2="20" y2="20" />
                </svg>
              </button>
            </div>
          ))}

        <div className="main-header fitted">
          <div className="botheader">
            <div className="container">
              <div className="row align-items-lg-center">
                <div
                  className={`col-xl-3 col-md-7 col-7 ${hasFooter ? "display-flex" : ""
                    }`}
                >
                  {!hasFooter ? (
                    <div
                      className="button"
                      onClick={() => {
                        setOpenModal(true);
                        setIsModal(false);
                      }}
                    ></div>
                  ) : (
                    <button
                      className="back-button-mob"
                      onClick={() => navigate(-1)}
                    >
                      <i className="fas fa-angle-left"></i>
                    </button>
                  )}
                  <div
                    className={
                      clientinfo?.giftLogo ? "logo-wrapper2" : "logo-wrapper1"
                    }
                  >
                    <Link to="/" className="logo-container">
                      <img
                        src={GetImageUrl(clientinfo?.logoUrl)}
                        alt="img"
                        className="main-logo"
                      />

                      {clientinfo?.giftLogo && (
                        <>
                          <div className="vertical-line"></div>
                          <img
                            src={GetImageUrl(clientinfo?.giftLogo)}
                            alt="img"
                            className="gift-logo"
                          />
                        </>
                      )}
                    </Link>
                  </div>
                </div>
                <div
                  className={`col-xl-3 ${!isLogin ? "col-md-2 col-2" : "col-md-3 col-3"}`}
                  style={{ paddingRight: isLogin ? "0px" : "0px" }}
                >
                  <div className="top-right clearfix">
                    <div className="search-container ">
                      <ul className="searchHeadphoneIcon">
                        <li className="search-icon-mobile">
                          <i
                            className={`las la-search home-tab ${!isLogin ? "loggedInSearch" : "mt-2"
                              }`}
                            onClick={toggleSearchBar}
                          ></i>
                        </li>
                        <li className="headphone-icon">
                          <a href="/contact-us">
                            <i className="las la-headphones home-tab"></i>
                          </a>
                        </li>
                      </ul>
                      {showSearch && (
                        <div className="search-bar-container" ref={dropdownRef}>
                          <div className="search-bar-wrapper">
                            <div className="search-bar-card">
                              <i className="las la-search search-input-icon"></i>
                              <input
                                type="text"
                                id="txtsearch"
                                className="search-bar"
                                value={searchTerm}
                                autoComplete="off"
                                onChange={handleChangeOptimized}
                              />
                            </div>

                            {/* Close Icon outside the card */}
                            <div className="close_icon">
                              <i
                                className="fa fa-close close-icon"
                                onClick={toggleSearchBar}
                              ></i>
                            </div>
                          </div>
                          {/* Search Suggestions */}
                          {searchTerm && (
                            <ul className="dropdown mt-1">
                              {filteredResults.length > 0 ? (
                                filteredResults.map((item) => (
                                  <li
                                    onClick={() => handleClick(item)}
                                    key={item.id}
                                    className="dropdown-item d-flex align-item-center"
                                  >
                                    <i
                                      className="las la-search mx-2"
                                      style={{ fontSize: "1.5em" }}
                                    ></i>{" "}
                                    {item.name}
                                  </li>
                                ))
                              ) : keepTyping ? (
                                <li className="dropdown-item item-align">
                                  {translation?.keepTyping}
                                </li>
                              ) : (
                                isSearching && (
                                  <li className="dropdown-item item-align">
                                    {translation?.NoRecordsFound}
                                  </li>
                                )
                              )}
                              {
                                hasMoreSearchResults && (
                                  // filteredResults.length > 0 &&
                                  <li
                                    ref={searchLoaderRef}
                                    className="dropdown-item text-center"
                                    style={{ minHeight: "10px" }}
                                  >
                                    {/* {isLoadingMore ? "Loading more..." : ""} */}
                                    {isLoadingMore ? (
                                      <span>Loading more...</span>
                                    ) : isSearching ? (
                                      <span style={{ opacity: 0 }}>
                                        Load trigger
                                      </span>
                                    ) : null}
                                  </li>
                                )

                                // )
                              }
                            </ul>
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                {isLogin ? (
                  <div
                    className={`col-xl-3 col-md-2 col-2 mt-1`}
                  // style={{ paddingLeft: isLogin && "50px" }}
                  >
                    <div className="top-right clearfix">
                      <div className="mt-4px">
                        <ul className="d-flex align-item-center justify-content-center">
                          <li className="meiconbtn">
                            <span
                              onClick={() => {
                                setIsModal((prev) => !prev);
                                setOpenModal(false);
                              }}
                            >
                              <div className="profile">
                                <div className="profile-initials">
                                  {getInitials(firstName, lastName)}
                                </div>
                              </div>
                            </span>
                            {isModal ? (
                              <div
                                className={`logindropbox ${currentBalance >= 0
                                    ? "logindrop-ch"
                                    : "logindrop-ch-no-points"
                                  }`}
                                ref={modal}
                              >
                                <div
                                  className={`logindrop2 ${currentBalance >= 0 ? "" : "logindrop3"
                                    }`}
                                >
                                  <ul>
                                    {currentBalance >= 0 &&
                                      isEarn !== 2 &&
                                      isBurn !== 2 && (
                                        <li className="pointBalance">
                                          {/* <img
                                        className="icon-sz"
                                        src={star}
                                        alt="profile"
                                      /> */}
                                          <i className="fa-solid fa-star buy mar"></i>{" "}
                                          <span className="current-poit">
                                            {currentBalance >= 0
                                              ? `${currentBalance.toLocaleString()} Pts`
                                              : "0 Pts"}
                                          </span>
                                        </li>
                                      )}
                                    <li>
                                      <img
                                        className="icon-sz"
                                        src={profile}
                                        alt="profile"
                                      />
                                      <Link
                                        to="/myprofile"
                                        onClick={() => setIsModal(false)}
                                        className="link-border"
                                      >
                                        {translation?.myProfile}
                                      </Link>
                                    </li>

                                    <li>
                                      <img
                                        className="icon-sz"
                                        src={order}
                                        alt="order"
                                      />
                                      <Link
                                        onClick={() => setIsModal(false)}
                                        to="/orders"
                                        className="link-border"
                                      >
                                        {translation?.orders}
                                      </Link>
                                    </li>

                                    <li>
                                      <img
                                        className="icon-sz"
                                        src={contact}
                                        alt="contactus"
                                      />
                                      <Link
                                        onClick={() => setIsModal(false)}
                                        to="/contact-us"
                                      >
                                        {translation?.contactUs}
                                      </Link>
                                    </li>
                                    <li>
                                      <img
                                        className="icon-sz"
                                        src={logout}
                                        alt="logout"
                                      />
                                      {/* <Logout width={18} color={"#919191"} height={18} className="icon-sz" /> */}
                                      <span
                                        onClick={handleLogout}
                                        className="logout-span"
                                      >
                                        Logout
                                      </span>

                                      {/* {translation?.myOrders} */}
                                    </li>
                                  </ul>
                                </div>
                              </div>
                            ) : (
                              " "
                            )}
                          </li>
                        </ul>
                      </div>
                    </div>{" "}
                  </div>
                ) : (isLoginDisabled?.isLoginDisabled !== 1 &&
                  <div
                    className={`col-xl-3 col-md-3 col-3 mt-1`}
                    style={{ paddingLeft: isLogin && "50px" }}
                  >
                    <div className="top-right clearfix">
                      <ul className="head-login">
                        <li id="ctl00_lnklogin">
                          {/* <Link to={V3Data?.SignInUrl} className="login_btn">
                            {translation?.loginLabel}
                          </Link> */}
                          <Link
                            to={V3Data?.SignInUrl}
                            onClick={() => handleLogin()}
                            className="login_btn"
                          >
                            {translation?.loginLabel}
                          </Link>
                        </li>
                      </ul>
                    </div>{" "}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>

        <div className="menu-nav">
          <div className="container">
            <div className={`top-menu ${OpenModal ? "topmenuopen" : ""}`}>
              <div className="d-block d-xl-none p-3">
                {OpenModal && (
                  <div onClick={() => setOpenModal(false)}>
                    <i className="las la-times closebtn"></i>
                  </div>
                )}
                <div className="mobilemenulogo text-center">
                  <img className="img" src={Logo2} alt="img" />
                </div>
              </div>

              <div
                className="sidebarMainDiv"
                style={{ maxHeight: isOpen ? "400px" : "47px" }}
              >
                <nav id="cssmenu">
                  {/* for the future scope  */}

                  <div className="heading-container heading-container_forMob">
                    <div className="sidebarImg">
                      <img src={sidebarImg} alt="Sidebar Icon" />
                      <div className="giftCard">
                        {" "}
                        {translation?.exploreGiftCards}
                      </div>
                    </div>
                    <div className="divider"></div>
                  </div>
                  <ul
                    className={`menu-items position_Relative_top_53 ${isOpen ? "open" : "closed"
                      }`}
                  >
                    {Object.keys(matchCategory)?.map((item1, index) => (
                      <li key={index}>
                        <Link
                          to={`/productlist?categoryId=${process.env.REACT_APP_IS_ENCRYPTION_ENABLED ===
                              "false"
                              ? item1
                              : encryptURLParam(item1)
                            }`}
                          state={{ item1 }}
                          onClick={() => {
                            // Close the sidebar after selecting a category
                            setOpenModal(false);
                          }}
                        >
                          {item1}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </nav>
              </div>
              {isLogin && (
                <div
                  className="sidebarSmallDiv"
                  style={{ maxHeight: isOpen ? "400px" : "47px" }}
                >
                  <nav id="cssmenu">
                    {/* for the future scope  */}

                    <div className="heading-container heading-container_forMob">
                      <div className="sidebarImg">
                        <img src={sidebarImg} alt="Sidebar Icon" />
                        <div className="giftCard">
                          {" "}
                          {translation?.exploreGiftCards}
                        </div>
                      </div>
                      <div className="divider"></div>
                    </div>
                    <ul className={` ${isOpen ? "open" : "closed"}`}>
                      <li>
                        <Link
                          onClick={() => {
                            setOpenModal(false);
                          }}
                          to="/myprofile"
                        >
                          {translation?.myAccount}
                        </Link>
                      </li>
                      <li>
                        <Link
                          onClick={() => {
                            setOpenModal(false);
                          }}
                          to="/orders"
                        >
                          {translation?.myOrders}
                        </Link>
                      </li>
                      {/* <li>
                      <Logout width={18} color={"#919191"} height={18} className="icon-sz" />
                      <span
                        onClick={handleLogout}
                        className="logout-span"
                      >
                        Logout
                      </span>

                      {/* {translation?.myOrders}

                    </li> */}
                    </ul>
                  </nav>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default MobileHeader;
